import { Main } from './pages';
import React from 'react';
import ReactDOM from 'react-dom';
import './styles/tailwind.css';

const mount = document.createElement('div');
document.body.appendChild(mount);

ReactDOM.render(<Main />, mount);
